const DELIMITER = '.';
export function set(obj, path, value) {
    if (obj == null) {
        throw new Error('Cannot set value on null or undefined');
    }
    const keys = toPathObject(path);
    let current = obj;
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        // Last key → assign value
        if (i === keys.length - 1) {
            current[key] = value;
            break;
        }
        // Create object or array if missing
        const nextKey = keys[i + 1];
        if (!(key in current) || current[key] == null) {
            current[key] = typeof nextKey === 'number' ? [] : {};
        }
        else if (typeof current[key] !== 'object' || current[key] === null) {
            // Overwrite non-object values
            current[key] = typeof nextKey === 'number' ? [] : {};
        }
        current = current[key];
    }
    return obj;
}
export function toPathObject(path) {
    if (Array.isArray(path)) {
        return path;
    }
    return path
        .split(DELIMITER)
        .map((segment) => (isNumericSegment(segment) ? Number(segment) : segment));
}
function isNumericSegment(segment) {
    return /^\d+$/.test(segment);
}
